//
// Copyright 2021 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_client_invitation } from "./invitation_pb.js";
import { file_dxos_devtools_swarm } from "../devtools/swarm_pb.js";
import { file_dxos_echo_metadata } from "../echo/metadata_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import { file_dxos_error } from "../error_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_mesh_signal } from "../mesh/signal_pb.js";
import { file_dxos_mesh_presence } from "../mesh/presence_pb.js";
/**
 * Describes the file dxos/client/services.proto.
 */
export const file_dxos_client_services = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_dxos_client_invitation, file_dxos_devtools_swarm, file_dxos_echo_metadata, file_dxos_echo_timeframe, file_dxos_error, file_dxos_halo_credentials, file_dxos_keys, file_dxos_mesh_signal, file_dxos_mesh_presence]);
/**
 * Describes the message dxos.client.services.Platform.
 * Use `create(PlatformSchema)` to create a new message.
 */
export const PlatformSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 0);
/**
 * @generated from enum dxos.client.services.Platform.PLATFORM_TYPE
 */
export var Platform_PLATFORM_TYPE;
(function (Platform_PLATFORM_TYPE) {
    /**
     * @generated from enum value: BROWSER = 0;
     */
    Platform_PLATFORM_TYPE[Platform_PLATFORM_TYPE["BROWSER"] = 0] = "BROWSER";
    /**
     * / @deprecated The shared-worker services path was removed. Value reserved for wire compatibility.
     *
     * @generated from enum value: SHARED_WORKER = 1;
     */
    Platform_PLATFORM_TYPE[Platform_PLATFORM_TYPE["SHARED_WORKER"] = 1] = "SHARED_WORKER";
    /**
     * @generated from enum value: NODE = 2;
     */
    Platform_PLATFORM_TYPE[Platform_PLATFORM_TYPE["NODE"] = 2] = "NODE";
    /**
     * @generated from enum value: DEDICATED_WORKER = 3;
     */
    Platform_PLATFORM_TYPE[Platform_PLATFORM_TYPE["DEDICATED_WORKER"] = 3] = "DEDICATED_WORKER";
})(Platform_PLATFORM_TYPE || (Platform_PLATFORM_TYPE = {}));
/**
 * Describes the enum dxos.client.services.Platform.PLATFORM_TYPE.
 */
export const Platform_PLATFORM_TYPESchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 0, 0);
/**
 * Describes the message dxos.client.services.Identity.
 * Use `create(IdentitySchema)` to create a new message.
 */
export const IdentitySchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 1);
/**
 * Describes the message dxos.client.services.RecoverIdentityRequest.
 * Use `create(RecoverIdentityRequestSchema)` to create a new message.
 */
export const RecoverIdentityRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 2);
/**
 * Describes the message dxos.client.services.RecoverIdentityRequest.ExternalSignature.
 * Use `create(RecoverIdentityRequest_ExternalSignatureSchema)` to create a new message.
 */
export const RecoverIdentityRequest_ExternalSignatureSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 2, 0);
/**
 * Describes the message dxos.client.services.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 3);
/**
 * TODO(nf): dedupe?
 *
 * @generated from enum dxos.client.services.Device.PresenceState
 */
export var Device_PresenceState;
(function (Device_PresenceState) {
    /**
     * @generated from enum value: OFFLINE = 0;
     */
    Device_PresenceState[Device_PresenceState["OFFLINE"] = 0] = "OFFLINE";
    /**
     * @generated from enum value: ONLINE = 1;
     */
    Device_PresenceState[Device_PresenceState["ONLINE"] = 1] = "ONLINE";
    /**
     * @generated from enum value: REMOVED = 2;
     */
    Device_PresenceState[Device_PresenceState["REMOVED"] = 2] = "REMOVED";
})(Device_PresenceState || (Device_PresenceState = {}));
/**
 * Describes the enum dxos.client.services.Device.PresenceState.
 */
export const Device_PresenceStateSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 3, 0);
/**
 * Describes the message dxos.client.services.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 4);
/**
 * Describes the message dxos.client.services.ContactBook.
 * Use `create(ContactBookSchema)` to create a new message.
 */
export const ContactBookSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 5);
/**
 * Describes the message dxos.client.services.SpaceMember.
 * Use `create(SpaceMemberSchema)` to create a new message.
 */
export const SpaceMemberSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 6);
/**
 * @generated from enum dxos.client.services.SpaceMember.PresenceState
 */
export var SpaceMember_PresenceState;
(function (SpaceMember_PresenceState) {
    /**
     * @generated from enum value: OFFLINE = 0;
     */
    SpaceMember_PresenceState[SpaceMember_PresenceState["OFFLINE"] = 0] = "OFFLINE";
    /**
     * @generated from enum value: ONLINE = 1;
     */
    SpaceMember_PresenceState[SpaceMember_PresenceState["ONLINE"] = 1] = "ONLINE";
})(SpaceMember_PresenceState || (SpaceMember_PresenceState = {}));
/**
 * Describes the enum dxos.client.services.SpaceMember.PresenceState.
 */
export const SpaceMember_PresenceStateSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 6, 0);
/**
 * Describes the message dxos.client.services.Space.
 * Use `create(SpaceSchema)` to create a new message.
 */
export const SpaceSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 7);
/**
 * Describes the message dxos.client.services.Space.Metrics.
 * Use `create(Space_MetricsSchema)` to create a new message.
 */
export const Space_MetricsSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 7, 0);
/**
 * Describes the message dxos.client.services.Space.PipelineState.
 * Use `create(Space_PipelineStateSchema)` to create a new message.
 */
export const Space_PipelineStateSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 7, 1);
/**
 * Describes the message dxos.client.services.QuerySpacesResponse.
 * Use `create(QuerySpacesResponseSchema)` to create a new message.
 */
export const QuerySpacesResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 8);
/**
 * Describes the message dxos.client.services.CreateEpochResponse.
 * Use `create(CreateEpochResponseSchema)` to create a new message.
 */
export const CreateEpochResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 9);
/**
 * Describes the message dxos.client.services.ContactAdmission.
 * Use `create(ContactAdmissionSchema)` to create a new message.
 */
export const ContactAdmissionSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 10);
/**
 * Describes the message dxos.client.services.JoinSpaceResponse.
 * Use `create(JoinSpaceResponseSchema)` to create a new message.
 */
export const JoinSpaceResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 11);
/**
 * Describes the message dxos.client.services.InvitationMethod.
 * Use `create(InvitationMethodSchema)` to create a new message.
 */
export const InvitationMethodSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 12);
/**
 * Describes the message dxos.client.services.QueryInvitationsResponse.
 * Use `create(QueryInvitationsResponseSchema)` to create a new message.
 */
export const QueryInvitationsResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 13);
/**
 * @generated from enum dxos.client.services.QueryInvitationsResponse.Action
 */
export var QueryInvitationsResponse_Action;
(function (QueryInvitationsResponse_Action) {
    /**
     * @generated from enum value: ADDED = 0;
     */
    QueryInvitationsResponse_Action[QueryInvitationsResponse_Action["ADDED"] = 0] = "ADDED";
    /**
     * @generated from enum value: REMOVED = 1;
     */
    QueryInvitationsResponse_Action[QueryInvitationsResponse_Action["REMOVED"] = 1] = "REMOVED";
    /**
     * @generated from enum value: SAVED = 2;
     */
    QueryInvitationsResponse_Action[QueryInvitationsResponse_Action["SAVED"] = 2] = "SAVED";
    /**
     * @generated from enum value: LOAD_COMPLETE = 3;
     */
    QueryInvitationsResponse_Action[QueryInvitationsResponse_Action["LOAD_COMPLETE"] = 3] = "LOAD_COMPLETE";
})(QueryInvitationsResponse_Action || (QueryInvitationsResponse_Action = {}));
/**
 * Describes the enum dxos.client.services.QueryInvitationsResponse.Action.
 */
export const QueryInvitationsResponse_ActionSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 13, 0);
/**
 * @generated from enum dxos.client.services.QueryInvitationsResponse.Type
 */
export var QueryInvitationsResponse_Type;
(function (QueryInvitationsResponse_Type) {
    /**
     * @generated from enum value: CREATED = 0;
     */
    QueryInvitationsResponse_Type[QueryInvitationsResponse_Type["CREATED"] = 0] = "CREATED";
    /**
     * @generated from enum value: ACCEPTED = 1;
     */
    QueryInvitationsResponse_Type[QueryInvitationsResponse_Type["ACCEPTED"] = 1] = "ACCEPTED";
})(QueryInvitationsResponse_Type || (QueryInvitationsResponse_Type = {}));
/**
 * Describes the enum dxos.client.services.QueryInvitationsResponse.Type.
 */
export const QueryInvitationsResponse_TypeSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 13, 1);
/**
 * Describes the message dxos.client.services.LoadPersistentInvitationsResponse.
 * Use `create(LoadPersistentInvitationsResponseSchema)` to create a new message.
 */
export const LoadPersistentInvitationsResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 14);
/**
 * Describes the message dxos.client.services.NetworkStatus.
 * Use `create(NetworkStatusSchema)` to create a new message.
 */
export const NetworkStatusSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 15);
/**
 * Describes the message dxos.client.services.NetworkStatus.Signal.
 * Use `create(NetworkStatus_SignalSchema)` to create a new message.
 */
export const NetworkStatus_SignalSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 15, 0);
/**
 * Describes the message dxos.client.services.EdgeStatus.
 * Use `create(EdgeStatusSchema)` to create a new message.
 */
export const EdgeStatusSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 16);
/**
 * @generated from enum dxos.client.services.EdgeStatus.ConnectionState
 */
export var EdgeStatus_ConnectionState;
(function (EdgeStatus_ConnectionState) {
    /**
     * @generated from enum value: NOT_CONNECTED = 0;
     */
    EdgeStatus_ConnectionState[EdgeStatus_ConnectionState["NOT_CONNECTED"] = 0] = "NOT_CONNECTED";
    /**
     * @generated from enum value: CONNECTED = 1;
     */
    EdgeStatus_ConnectionState[EdgeStatus_ConnectionState["CONNECTED"] = 1] = "CONNECTED";
})(EdgeStatus_ConnectionState || (EdgeStatus_ConnectionState = {}));
/**
 * Describes the enum dxos.client.services.EdgeStatus.ConnectionState.
 */
export const EdgeStatus_ConnectionStateSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 16, 0);
/**
 * Describes the message dxos.client.services.QueryEdgeStatusResponse.
 * Use `create(QueryEdgeStatusResponseSchema)` to create a new message.
 */
export const QueryEdgeStatusResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 17);
/**
 * Describes the message dxos.client.services.QueryAgentStatusResponse.
 * Use `create(QueryAgentStatusResponseSchema)` to create a new message.
 */
export const QueryAgentStatusResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_client_services, 18);
/**
 * @generated from enum dxos.client.services.QueryAgentStatusResponse.AgentStatus
 */
export var QueryAgentStatusResponse_AgentStatus;
(function (QueryAgentStatusResponse_AgentStatus) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    QueryAgentStatusResponse_AgentStatus[QueryAgentStatusResponse_AgentStatus["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: ACTIVE = 1;
     */
    QueryAgentStatusResponse_AgentStatus[QueryAgentStatusResponse_AgentStatus["ACTIVE"] = 1] = "ACTIVE";
    /**
     * @generated from enum value: INACTIVE = 2;
     */
    QueryAgentStatusResponse_AgentStatus[QueryAgentStatusResponse_AgentStatus["INACTIVE"] = 2] = "INACTIVE";
    /**
     * @generated from enum value: NOT_FOUND = 3;
     */
    QueryAgentStatusResponse_AgentStatus[QueryAgentStatusResponse_AgentStatus["NOT_FOUND"] = 3] = "NOT_FOUND";
})(QueryAgentStatusResponse_AgentStatus || (QueryAgentStatusResponse_AgentStatus = {}));
/**
 * Describes the enum dxos.client.services.QueryAgentStatusResponse.AgentStatus.
 */
export const QueryAgentStatusResponse_AgentStatusSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 18, 0);
/**
 * @generated from enum dxos.client.services.SystemStatus
 */
export var SystemStatus;
(function (SystemStatus) {
    /**
     * @generated from enum value: INACTIVE = 0;
     */
    SystemStatus[SystemStatus["INACTIVE"] = 0] = "INACTIVE";
    /**
     * @generated from enum value: ACTIVE = 1;
     */
    SystemStatus[SystemStatus["ACTIVE"] = 1] = "ACTIVE";
})(SystemStatus || (SystemStatus = {}));
/**
 * Describes the enum dxos.client.services.SystemStatus.
 */
export const SystemStatusSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 0);
/**
 * @generated from enum dxos.client.services.DeviceKind
 */
export var DeviceKind;
(function (DeviceKind) {
    /**
     * @generated from enum value: CURRENT = 0;
     */
    DeviceKind[DeviceKind["CURRENT"] = 0] = "CURRENT";
    /**
     * @generated from enum value: TRUSTED = 1;
     */
    DeviceKind[DeviceKind["TRUSTED"] = 1] = "TRUSTED";
})(DeviceKind || (DeviceKind = {}));
/**
 * Describes the enum dxos.client.services.DeviceKind.
 */
export const DeviceKindSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 1);
/**
 * TODO(wittjosiah): Rename to SwarnState?
 *
 * @generated from enum dxos.client.services.ConnectionState
 */
export var ConnectionState;
(function (ConnectionState) {
    /**
     * @generated from enum value: OFFLINE = 0;
     */
    ConnectionState[ConnectionState["OFFLINE"] = 0] = "OFFLINE";
    /**
     * @generated from enum value: ONLINE = 1;
     */
    ConnectionState[ConnectionState["ONLINE"] = 1] = "ONLINE";
})(ConnectionState || (ConnectionState = {}));
/**
 * Describes the enum dxos.client.services.ConnectionState.
 */
export const ConnectionStateSchema = /*@__PURE__*/ enumDesc(file_dxos_client_services, 2);
//# sourceMappingURL=services_pb.js.map